module.exports = __webpack_public_path__ + "img/6hearts.edb20164.jpg";